import { SocialProfile } from './socialprofile';
export class SocialProfileGroup{
    public name: string = '';
    public details: SocialProfile[] = [];
}